// Entegrasyon sağlayıcı kaydı (registry).
//
// planIntegration: backend PlanIntegration enum kodu. Kartın paket kapsamında olup
// olmadığı buradan anlaşılır; kodu OLMAYAN sağlayıcı (henüz backend'i yok, "soon")
// kilitlenmez, zaten "Yakında" olarak çizilir.
// Kart-grid hub bu listeyi kategoriye göre gruplayıp render eder.
// Durum (Aktif/Pasif) sağlayıcının kendi hook'undan türetilir; burada yalnızca
// statik meta (ad, kategori, açıklama, logo/ikon) tutulur.

export const CATEGORIES = [
    { id: "payment", label: "Ödeme Kuruluşu" },
    { id: "bank", label: "Bankalar" },
    { id: "accounting", label: "Muhasebe" },
];

// logo: public altındaki gerçek görsel (varsa). Yoksa icon + accent ile renkli kutu.
export const INTEGRATIONS = [
    // ─── Ödeme Kuruluşu ───────────────────────────────────────
    {
        id: "isyerimpos",
        planIntegration: "POS_ISYERIM",
        name: "İşyerimPOS",
        category: "payment",
        description: "Sanal POS & 3D Secure ödeme entegrasyonu",
        logo: "/images/payments/isyerimpos.png",
    },
    {
        id: "paytr",
        planIntegration: "POS_PAYTR",
        name: "PayTR",
        category: "payment",
        description: "Sanal POS & ödeme sistemi entegrasyonu",
        logo: "/images/payments/paytr.png",
    },
    // Param POS ürün kararıyla panelden GİZLENDİ. Backend entegrasyonu (ayar uçları,
    // ödeme akışı, iade) olduğu gibi duruyor; hâlihazırda bağlı firmalar çalışmaya
    // devam eder — yalnız bu ekranda yeni bağlantı kurulamaz. Geri açmak için
    // aşağıdaki bloğun yorumunu kaldırmak yeterli.
    // {
    //     id: "param",
    //     planIntegration: "POS_PARAMPOS",
    //     name: "Param POS",
    //     category: "payment",
    //     description: "Dijital ödeme altyapısı & açık bankacılık",
    //     logo: "/images/payments/param.png",
    // },
    {
        id: "esnekpos",
        planIntegration: "POS_ESNEK_POS",
        name: "Hoppa",
        category: "payment",
        description: "Ödeme & tahsilat platformu entegrasyonu",
        logo: "/images/payments/hoppa.jpeg",
    },
    { id: "iyzico", planIntegration: "POS_IYZICO", name: "iyzico", category: "payment", description: "Online ödeme çözümleri & sanal POS altyapısı", logo: "/images/payments/iyzico.svg", status: "soon" },
    { id: "nkolay", name: "NKolay", category: "payment", description: "Ödeme & tahsilat altyapısı", logo: "/images/payments/nkolay.svg", status: "soon" },

    // ─── Bankalar ─────────────────────────────────────────────
    {
        id: "qnb_payfor",
        planIntegration: "POS_QNB_PAYFOR",
        name: "QNB",
        category: "bank",
        description: "Sanal POS & ödeme entegrasyonu",
        logo: "/images/payments/qnb.png",
    },
    // (aşağıdakiler backend entegrasyonu henüz yok → "soon")
    { id: "isbankasi", name: "İş Bankası", category: "bank", description: "Sanal POS & otomatik ödeme tahsilatı", logo: "/images/banks/isbankasi.png", status: "soon" },
    { id: "akbank", name: "Akbank", category: "bank", description: "Sanal POS entegrasyonu", logo: "/images/banks/akbank.png", status: "soon" },
    { id: "garanti", planIntegration: "POS_GARANTI", name: "Garanti BBVA", category: "bank", description: "Sanal POS & EFT tahsilatı", logo: "/images/banks/garanti.png" },
    { id: "yapikredi", name: "Yapı Kredi", category: "bank", description: "Sanal POS entegrasyonu", logo: "/images/banks/yapikredi.png", status: "soon" },
    { id: "ziraat", name: "Ziraat Bankası", category: "bank", description: "Sanal POS & tahsilat sistemi", logo: "/images/banks/ziraat.png", status: "soon" },
    { id: "halkbank", name: "Halkbank", category: "bank", description: "Sanal POS entegrasyonu", logo: "/images/banks/halkbank.png", status: "soon" },

    // ─── Muhasebe ─────────────────────────────────────────────
    {
        id: "parasut",
        planIntegration: "ACC_PARASUT",
        name: "Paraşüt",
        category: "accounting",
        description: "Bulut muhasebe & fatura yönetimi",
        logo: "/images/payments/parasut.png",
    },
    {
        id: "bizimhesap",
        planIntegration: "ACC_BIZIMHESAP",
        name: "Bizim Hesap",
        category: "accounting",
        description: "KOBİ odaklı muhasebe & finans takibi",
        logo: "/images/payments/bizim-hesap.png",
    },
];

// "Yakında" (soon) sağlayıcılar kategori içinde her zaman en sonda listelenir;
// kendi aralarındaki ve diğerlerinin sırası registry sırasıdır (stable sort).
export const integrationsByCategory = (category) =>
    INTEGRATIONS.filter((i) => i.category === category)
        .sort((a, b) => (a.status === "soon" ? 1 : 0) - (b.status === "soon" ? 1 : 0));
